import { get, post } from "./../util/request.js";
import { baseApi } from "./../util/base.js";
// 获取所属城市老年大学
export function getSchoolList(data) {
  return get(baseApi + `/v11/loginconf/getschool/city/${data}`);
}
// 获取所属大学id
export function getSchoolId(data){
  return get(baseApi + `/v11/loginconf/getschoolby/name/${data}`);
}